<template lang="html">
<form @submit.prevent="onSave()">
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit trace</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Description">
        <b-input
          type="textarea"
          minlength="0"
          maxlength="256"
          v-model="description"
          :has-counter="false"
          :use-html5-validation="false">
        </b-input>
      </b-field>
      <div v-if="errorMsg !== ''">
        <p>Something went wrong please try again later</p>
        <p class="is-family-code has-text-danger">{{ errorMsg }}</p>
      </div>
    </section>
    <footer class="modal-card-foot">
      <b-button
        @click="$parent.close()">
        Close
      </b-button>
      <b-button
        native-type="submit">
        Save
      </b-button>
    </footer>
  </div>
</form>
</template>

<script>
import Trace from '@/models/Trace'
import api from '@/utils/api'

export default {
  props: {
    trace: {
      type: Trace,
      required: true
    }
  },
  data () {
    return {
      description: this.trace.description,
      errorMsg: ''
    }
  },
  methods: {
    onSave () {
      api.updateTrace(this.trace, {
        description: this.description
      })
        .then((response) => {
          this.$parent.close()
        })
        .catch((response) => {
          this.errorMsg = response
        })
    }
  }
}
</script>
